import { render, staticRenderFns } from "./DefaultPageWithIcon.vue?vue&type=template&id=44a8b066&"
import script from "./DefaultPageWithIcon.vue?vue&type=script&lang=ts&"
export * from "./DefaultPageWithIcon.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports